import { render, staticRenderFns } from "./ImportInvoices.vue?vue&type=template&id=22e81f50&scoped=true&"
import script from "./ImportInvoices.vue?vue&type=script&lang=js&"
export * from "./ImportInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e81f50",
  null
  
)

export default component.exports